import { render, staticRenderFns } from "./sectionsDetails.vue?vue&type=template&id=2ab861b1&"
import script from "./sectionsDetails.vue?vue&type=script&lang=js&"
export * from "./sectionsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports